import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  previousSibling
  config = {
    rootMargin: "-100px",
    threshold: [0.2, 0.4, 0.6, 0.8, 1.0]
  }

  connect() {
    console.log("connected")
    window.addEventListener("DOMContentLoaded", this.listenToScroll())
    this.initImageZoom()
  }

  // Powiększenie obrazka po kliknięciu (lightbox)
  initImageZoom() {
    const images = this.element.querySelectorAll(".syntax-content img")
    images.forEach(img => {
      img.style.cursor = "zoom-in"
      img.addEventListener("click", () => this.openImageOverlay(img.src, img.alt))
    })
  }

  openImageOverlay(src, alt) {
    const overlay = document.createElement("div")
    overlay.className = "kb-image-overlay"
    overlay.innerHTML = `<img src="${src}" alt="${alt || ""}">`
    overlay.addEventListener("click", () => overlay.remove())
    document.addEventListener("keydown", function handler(e) {
      if (e.key === "Escape") { overlay.remove(); document.removeEventListener("keydown", handler) }
    })
    document.body.appendChild(overlay)
  }

  listenToScroll() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute("id")
        const sectionsCollection = {}

        if (entry.target.getBoundingClientRect().top <= 100) {
          // chce tutaj wlaczyc tlo dla tego naglowka ktory wlasnie przekroczyl gore strony
          // musze dodac jeszcze wykrywanie scrolla zeby ten z previousiblingiem wykonywal sie tylko podczas scrolla do gory
          const activeLink = document.querySelector(`nav a[href="#${id}"]`)
          if (activeLink) {
            activeLink.classList.add("!text-gray-900")
            activeLink.parentElement.classList.add("!border-blue-500")
          }
          const navs = document.querySelectorAll("nav#entry-sections a, nav#on-this-page a")

          // get a collection of all headers with their corresponding paragraphs
          navs.forEach(nav => {
            const headerId = `${nav.getAttribute("href")}`
            if (headerId !== `#${id}`) {
              nav.classList.remove("!text-gray-900")
              nav.parentElement.classList.remove("!border-blue-500")
            }
            const headerElement = document.querySelector(headerId)
            const headerParagraph = headerElement.nextElementSibling
            sectionsCollection[headerId] = headerParagraph
          })
        }

        // ponizsze jest proba podswietlania headera na podstawie paragrafu ktory nastepuje po nim podczas
        // scrollowania w gore, jednak nie dziala to podczas scrollowania w dol, do przemyslenia
        // this.previousSibling = entry.target.previousElementSibling
        // const key = this.getKeyByValue(sectionsCollection, this.previousSibling).toString()
        // const keyElement = document.querySelector(key)
        // if (entry.target.previousElementSibling === keyElement.nextElementSibling) {
        //   console.log('is intersecting')
        //   document.querySelector(`nav a[href="${key}"]`).classList.add('bg-gray-50', 'text-gray-900')
        //   document.querySelector(`nav a[href="#${id}"]`).classList.remove('bg-gray-50', 'text-gray-900')
        // }
      })
    }, this.config)

    // Track all headers that have an `id` applied
    document.querySelectorAll("h2[id], h3[id], h4[id], h5[id]").forEach((header) => {
      observer.observe(header)
    })
  }

  // getKeyByValue(object, value) {
  //   return Object.keys(object).find(key => object[key] === value)
  // }
}
